export class StoreService {
  public static getObject(key: string): Object {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
  public static setObject<T extends Object>(key: string, obj: T): void {
    if (obj || obj === null) {
      localStorage.setItem(key, JSON.stringify(obj));
    }
  }
  public static remove(key: string): void {
    localStorage.removeItem(key);
  }
  public static getString(key: string): string {
    return localStorage.getItem(key);
  }
  public static setString(key: string, str: string): void {
    localStorage.setItem(key, str);
  }
}
